import React from 'react'

export interface CoveredEntityDescriptionProps {
  className?: string
}

const CoveredEntityDescription: React.FC<CoveredEntityDescriptionProps> = ({ className }) => {
  return (
    <p className={className}>
      Covered entities under the Health Insurance Portability and Accountability Act (HIPAA) include
      healthcare providers that transmit protected health information in connection with a
      transaction for which the Department of Health and Human Services has adopted standards (see
      45 CFR 160.103). Covered transactions include the transmission of healthcare claims, payment
      and remittance advice, healthcare status, coordination of benefits, enrollment and
      disenrollment, eligibility checks, healthcare electronic fund transfers, and referral
      certification and authorization. The HIPAA rules also apply to business associates of
      HIPAA-covered entities and their subcontractors.
    </p>
  )
}

export default CoveredEntityDescription
